import { render } from "./document-block.vue?vue&type=template&id=27cb8a02&scoped=true&ts=true&lang=pug"
import script from "./document-block.vue?vue&type=script&lang=ts"
export * from "./document-block.vue?vue&type=script&lang=ts"

import "./document-block.vue?vue&type=style&index=0&id=27cb8a02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cb8a02"]])

export default __exports__